import React, { useEffect, useRef, useState, forwardRef } from "react";
import { useTranslation } from 'react-i18next';
import {
  registerQuickAddAutoComplete,
  quickAddEventHandler,
  removeEmojiContent,
  getUserId,
  getWsTagId
} from "../../utils/common";

import CommonTags, {
  autoResizeTextArea,
  resetTextAreaHeight
} from "./commonTags";

export const MeetingTakeawayTextArea = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const { userPermission, meetingObj, saveTags, takeTopicId, currentUser } = props;
  const emptyNoteArea = "meetingagendatextboxempty";
  const textareaId = `meeting_take_${meetingObj.id}`;
  const type = 'take';

  const getReturnTag = (tagId) => props.onTakeTag(tagId);

  const getEleId = () => `meeting_take_${meetingObj.id}`

  const openTextArea = (event) => {
    const eleId = getEleId();
    const tag = $(event.target)
      .closest(".meeting-take-sec")
      .find(".meeting-tag-options")
      .attr("data-tag");

    props.onTakeTag(tag);
    props.onDoneBtn(true);

    if(typeof eleId != 'undefined' && eleId){
      // TODO: initializeMeetingEditor is an example of global variable
      initializeMeetingEditor(eleId, props.onSubmit);
    }
    autoResizeTextArea({ eleId: `#${eleId}` });

    if ($(`#${eleId}`).parents(".meeting_take_sortable").length) {
      $(`#${eleId}`)
        .parents(".meeting_take_sortable")
        .addClass("bgwhite");
    }
    if (takeTopicId != "") {
      props.clearGlobalValue();
    }
  }

  const takeawayLiveSync = () => {
    let timeoutId = null;
    // Notify typing event
     // TODO: More global functions
    if (!getMeetingTyping()) {
      typing("meet");
      setMeetingTyping(true);
    } else {
      if(timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        typingTimeOut("meet");
      }, 3500);
    }
    // if user is typing and both the users are active in meeting, then display the warning
    if ($("#typing-alert").css("display") == "none") {
      // element is hidden
      $(".topic-alert")
        .delay(100)
        .fadeOut();
    } else {
      $(".topic-alert")
        .delay(500)
        .fadeIn();
    }

    const eleId = getEleId();
    autoResizeTextArea({ eleId: `#${eleId}` });
  }

  useEffect(() => {
    if (
      typeof userPermission.execute !== "undefined" &&
      userPermission.execute == "1"
    ) {
      const _id = `#meeting_take_${meetingObj.id}`;
      registerQuickAddAutoComplete(_id);
    }
  }, []);

  return (
    <div
        ref={wrapperRef}
        className={`takeawayHead  displayCell`}
        style={{ minHeight: "40px" }}
      >
        <div className="oneonone-expand ">
          <div className={`wb-textarea-container addTakeawayContainer`}>
            <div className={`type-enter-box`}>
              <div className={`width100 meeting-take-sec takeawayyContainer`} >
                <CommonTags
                  owner={currentUser.id}
                  key={`topic_take_`}
                  meeting={meetingObj}
                  userPermission={userPermission}
                  currentUser={currentUser}
                  tag={props.tag}
                  type={type}
                  act={'add'}
                  saveTags={saveTags}
                  getReturnTag={getReturnTag}
                  emptyArea={true}
                />
                <div
                  className={`meetingagendatextbox meetingTakeNote ${emptyNoteArea}`}
                  ref={ref}
                  placeholder={t('Add takeaways here')}
                  id={textareaId}
                  data-enable-quickadd="true"
                  data-tag={props.tag}
                  style={{ width: "88%", paddingLeft: '60px' }}
                  onKeyDown={props.onKeyDown}
                  onKeyPress={takeawayLiveSync}
                  onFocus={openTextArea}
                  onClick={openTextArea}
                  data-attr-takeaway="true"
                />
                
              </div>
            </div>
            {props.showDoneBtn ? (
              <button
                onClick={props.onSubmit}
                className="btn-circle subTakeBtn"
                style={{marginTop: "-41px",pointerEvents: 'unset'}}
              >
                <span className="icon icon-outline-check-24px-blue"></span>
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        
      </div>
  );
});
